export default __webpack_public_path__ + "static/media/collapse.39e445df.svg";